<template>
  <!--
      	作者：gmshop
      	时间：2020-06-01
      	描述：插件中心-文章-列表
      -->
  <div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addArticle" v-auth="'/plus/article/article/add'">添加文章</el-button>
      <el-button size="small" type="primary" icon="el-icon-check" @click="openPopup('batch')" v-auth="'/plus/article/article/batch'">批量操作</el-button>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" ref="dragTable" v-loading="loading" :row-key="getRowKey"  @selection-change="tableCurrentChange">
        <el-table-column type="selection" :reserve-selection="true" align="center" width="45"></el-table-column>
        <el-table-column prop="article_id" label="文章ID" width="60"></el-table-column>
        <el-table-column prop="address" label="封面" width="50">
          <template slot-scope="scope">
            <img v-if="scope.row.image && scope.row.image.file_path" :src="scope.row.image.file_path" width="30" height="30" />
          </template>
        </el-table-column>
        <el-table-column prop="article_title" label="文章标题">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.article_title">{{scope.row.article_title}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="category.name" label="文章分类" width="120"></el-table-column>
        <el-table-column prop="virtual_views" label="实际阅读量" width="100"></el-table-column>
        <el-table-column prop="article_sort" label="文章排序" width="100"></el-table-column>
        <el-table-column prop="article_status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.article_status == 1" class="green">显示</span>
            <span v-if="scope.row.article_status == 0" class="gray">隐藏</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
        <el-table-column prop="name" label="操作" width="90">
          <template slot-scope="scope">
            <el-button @click="editArticle(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="deleteArticle(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>

    <!--批量-->
    <Batch v-if="show_popup['batch']" :is_open="show_popup['batch']" :ids="batchIds" @closeDialog="closeDialogFunc($event, 'batch')"></Batch>
  </div>
</template>

<script>
import ArticleApi from '@/api/article.js';
import Batch from './batch';
export default {
  components: {
    Batch
  },
  data() {
    return {
      /*分类*/
      categoryData: [],
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*弹窗*/
      show_popup: {
        batch: false,
      },
      /*批量选中ids*/
      batchIds: [],
    };
  },
  created() {
    /*获取文章列表*/
    this.getTableList();
  },
  methods: {
    // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
    getRowKey (row) {
      return row.article_id;
    },
    /*监听复选按钮选中事件*/
    tableCurrentChange(val) {
      this.batchIds = [];
      val.forEach(e => {
        this.batchIds.push(e.article_id);
      });
    },
    /*获取文章列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      ArticleApi.articlelist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*添加文章*/
    addArticle() {
      this.$router.push({
        path: '/plus/article/article/Add'
      });
    },

    /*编辑文章*/
    editArticle(row) {
      let params = row.article_id;
      this.$router.push({
        path: '/plus/article/article/Edit',
        query: {
          article_id: params
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

    /*删除文章*/
    deleteArticle(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          ArticleApi.deleteArticle(
            {
              article_id: row.article_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },

    /*删除文章分类*/
    deleteCategory(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          ArticleApi.deleteCategory(
            {
              category_id: row.category_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleClick(tab, event) {},

    /*打开分类添加*/
    addCategory() {
      this.open_add = true;
    },

    /*打开分类编辑*/
    editCategory(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*打开弹窗*/
    openPopup(name, item){
      this.show_popup[name] = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      this.show_popup[f] = e.openDialog;
      if (e.type == 'success') {
        this.getTableList();
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/article/article/Index.vue